import { getService } from "./service";
import { setCircularLoading } from "./UiReducer";
import { handleError } from "./ErrorReducer";
import { serviceNames } from "../utils/constants";

const initialState = {
  filters: [],
  loading: false,
  error: null,
};

const CREATE_FILTER_REQUEST = "CREATE_FILTER_REQUEST";
const CREATE_FILTER_SUCCESS = "CREATE_FILTER_SUCCESS";
const CREATE_FILTER_FAILURE = "CREATE_FILTER_FAILURE";

export const createScreenFilter =
  (screenName, name, filterValues, availableOnlyToMe) => async (dispatch) => {
    dispatch({ type: CREATE_FILTER_REQUEST });
    dispatch(setCircularLoading(true));

    try {
      const service = getService(serviceNames.perFilters);

      const payload = {
        screenName,
        name,
        filterValues: JSON.stringify(filterValues),
        availableToAll: !availableOnlyToMe,
      };

      let result;

      result = await service.create(payload);

      dispatch({ type: CREATE_FILTER_SUCCESS, payload: result });
    } catch (error) {
      dispatch({ type: CREATE_FILTER_FAILURE, payload: error.message });
      dispatch(handleError(error));
    } finally {
      dispatch(setCircularLoading(false));
    }
  };

export default function perFilterReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_FILTER_REQUEST:
      return { ...state, loading: true, error: null };

    case CREATE_FILTER_SUCCESS:
      return {
        ...state,
        loading: false,
        filters: [...state.filters, action.payload],
      };

    case CREATE_FILTER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
